// consent.service.ts
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class ConsentService {

  private readonly CONSENT_KEY = 'scripay_consent';

  constructor(private cookieService: CookieService) {}

  // Dynamically get the correct domain
  private getCookieDomain(): string {
    const hostname = window.location.hostname;

    // Production
    if (hostname.includes('scripay.com')) return '.scripay.com';

    // Local development
    if (hostname.includes('scripay.local')) return '.scripay.local';

    // Fallback (localhost)
    return 'localhost';
  }

  saveConsent(analytics: boolean, marketing: boolean): void {
    const consent = {
      analytics,
      marketing,
      timestamp: new Date().toISOString()
    };

    this.cookieService.set(
      this.CONSENT_KEY,
      JSON.stringify(consent),
      {
        expires: 365,
        path: '/',
        domain: this.getCookieDomain(),  // ✅ dynamic domain
        secure: false,                   // ✅ false for local (no HTTPS)
        sameSite: 'Lax'
      }
    );

    // Debug — confirm it saved
    console.log('Consent saved on domain:', this.getCookieDomain());
    console.log('Saved consent:', this.getConsent());
  }

  getConsent() {
    const data = this.cookieService.get(this.CONSENT_KEY);
    return data ? JSON.parse(data) : null;
  }

  hasConsented(): boolean {
    return this.cookieService.check(this.CONSENT_KEY);
  }

  revokeConsent(): void {
    this.cookieService.delete(this.CONSENT_KEY, '/', this.getCookieDomain());
  }
}